import APPL_WIN_DISP_DIV from "./framework/common/menus/applWinDispDiv"
import BARCODE_DIV from "./framework/common/menus/barcodeDiv"
import BO_CODE from "./framework/common/codes/boCode"
import DIGI_PON_DIV from "./framework/common/menus/digiPonDiv"
import DISPLAY_DIV from "./framework/common/subsidy/displayDiv"
import ENV from "./framework/common/env"
import PAYEE_DIV from "./framework/common/menus/payeeDiv"
import PAY_MTHD_DIV from "./framework/common/menus/payMthdDiv"
import PRICE_DIV from "./framework/common/orders/priceDiv"
import PYRL_DED_PAYEE_DIV from "./framework/common/menus/pyrlDedPayeeDiv"
import SRVIC_DIV from "./framework/common/menus/srvicDiv"
import USAGE_DIV from "./framework/common/menus/usageDiv"
import USED_FORM_DIV from "./framework/common/subsidy/usedFormDiv"
import CHILD_DIV from "./framework/stay/childDiv"
import SMOKING_DIV from "./framework/stay/smokingDiv"
import SUBSIDY_REQUEST_TYPE from "./framework/common/subsidy/requestType"
import COST_UNDER_CHARGEABLE_FLG from "./framework/common/subsidy/costUnderChargeableFlg"
import PERSON_ACCOMPANY_FLG from "./framework/common/subsidy/personAccompanyFlg"
import MULTIPLE_UNUSABLE_FLG from "./framework/common/subsidy/multipleUnusableFlg"
import BENEPO_RETURN_DIV from './framework/common/menus/benepoReturnDiv';
import STAY_PAYEE_DIV from './framework/stay/payeeDiv';

export default {
    APPL_WIN_DISP_DIV,
    BARCODE_DIV,
    BO_CODE,
    DIGI_PON_DIV,
    DISPLAY_DIV,
    ENV,
    PAYEE_DIV,
    PAY_MTHD_DIV,
    PRICE_DIV,
    PYRL_DED_PAYEE_DIV,
    SRVIC_DIV,
    USAGE_DIV,
    USED_FORM_DIV,
    CHILD_DIV,
    SMOKING_DIV,
    SUBSIDY_REQUEST_TYPE,
    COST_UNDER_CHARGEABLE_FLG,
    PERSON_ACCOMPANY_FLG,
    MULTIPLE_UNUSABLE_FLG,
    BENEPO_RETURN_DIV,
    STAY_PAYEE_DIV
}